import { extend, filter } from "lodash-es";
import { FiltersModalController } from "./FiltersModalController";
import { HostFamilyBase } from "../HostFamilyBase";

export class FindHostFamilyController extends HostFamilyBase {

    isOnlineOrAwaiting: boolean;
    isToBeMatch: boolean;
    isRematch: boolean;
    isActiveApp: boolean;
    isPlacedOrActive: boolean;
    isPlaced: boolean;

    isApplicant: boolean;

    filters

    hostFamilies;
    hostFamiliesLoaded: number;
    hostFamiliesTotal: number;


    currentLikes: number;
    maxLikes: number;


    loading: boolean;

    region = {
        'EAC': 'East Coast',
        'MAT': 'Mid Atlantic',
        'MIW': 'Mid West',
        'MT': 'Mountains',
        'NWG': 'New England',
        'NYM': 'NYC Metro Area',
        'SOU': 'South',
        'SOW': 'South West',
        'WEC': 'West Coast'
    }


    static override $inject = ['$scope', '$sce', '$uibModal', '$state', 'dialogs', 'applicationId', 'HostFamiliesResult', 'InterestedHostFamiliesDetails', 'applicationObservable', 'Auth', 'Activity']
    constructor($scope: angular.IScope, $sce, $uibModal, $state, private dialogs, applicationId, public HostFamiliesResult, InterestedHostFamiliesDetails, applicationObservable, private Auth, private Activity) {

        super($uibModal, InterestedHostFamiliesDetails, $state, applicationId);

        this.isApplicant = Auth.user.isApplicant;

        applicationObservable.subscribe(applicationInstance => {
            this.isToBeMatch = (applicationInstance.status === 'TBM');
            this.isRematch = (applicationInstance.status === 'REM');
            this.isActiveApp = (applicationInstance.status === 'ACT');
            this.isPlaced = (applicationInstance.status === 'PLC');
            this.isOnlineOrAwaiting = (applicationInstance.status === 'OLA' || applicationInstance.status === 'AWA');
            this.isPlacedOrActive = (applicationInstance.status === 'PLC' || applicationInstance.status === 'ACT');
        })

        if (Auth.user.isApplicant) {
            Activity.trackHFActivity({ applicationId: applicationId }, { type: 'APViewedFindHFPage' });
        }

        this.clearFilter(true);
    }

    openFilters() {
        
        this.$uibModal.open({
            templateUrl: 'areas/hostFamilies/findHostFamily/FiltersModal.html',
            controller: FiltersModalController,
            controllerAs: '$ctrl',
            backdrop: false,
            resolve: {
                filters: angular.copy(this.filters)
            }
        }).result.then((filters) => {
            if (this.Auth.user.isApplicant) {
                this.Activity.trackHFActivity({ applicationId: this.applicationId }, { type: 'APModifiedFindHFFilter', data: filters });
            }

            this.filters = filters;
            this.refreshResult()
        });
    }

    addRecord(dataset, newElements) {
        let lastChunk = dataset[dataset.length - 1];

        let i = 0
        if (lastChunk && lastChunk.length == 1) {
            lastChunk.push(newElements[i]);
            i++;
        }

        for (; i < newElements.length; i += 2) {
            dataset.push(newElements.slice(i, i + 2));
        }
    }

    refreshResult() {
        this.hostFamilies = [];
        this.filters.pageNumber = 0;

        this.getData();
    }

    loadMore() {
        this.filters.pageNumber += 1;

        this.getData();
    }

    getData() {
        this.loading = true;

        this.HostFamiliesResult.query(this.filters)
            .$promise
            .then((data) => {
                this.addRecord(this.hostFamilies, data.result);
                this.hostFamiliesLoaded = this.hostFamilies.length * 2;
                if (this.hostFamilies.length > 0 && this.hostFamilies[this.hostFamilies.length - 1].length === 1) // last pair is not full
                    this.hostFamiliesLoaded -= 1;
                this.hostFamiliesTotal = data.total;
                this.currentLikes = data.currentLikes;
                this.maxLikes = data.maxLikes;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    hostFamiliesState() {
        return this.isApplicant ? "app.hostFamilies.interestedFamilies" : "app.applications.hostFamilies.interestedFamilies";
    }

    interested(hf) {
        //this.loading = true;

        this.openFeedbackDialog(hf, true)
            .result
            .then(() => {
                hf.interested = true;

                this.currentLikes++;
                this.InterestedHostFamiliesDetails.limits({ applicationId: this.applicationId })
                    .$promise
                    .then((limits) => {
                        this.currentLikes = limits.currentLikes;
                        this.maxLikes = limits.maxLikes;
                    })
            });



        //this.HostFamiliesResult
        //    .like({
        //        applicationId: this.filters.applicationId,
        //        hostFamilyId: hf.hostFamilyId
        //    })
        //    .$promise
        //    .then(() => {
        //        hf.interested = true;
        //    })
        //    .finally(() => {
        //        this.loading = false;
        //    });
    }

    notInterested(hf) {
        this.openFeedbackDialog(hf, false)
            .result
            .then(() => {
                hf.interested = false;
            });
    }

    bookmarkToggle(hf) {
        this.HostFamiliesResult.bookmark({
            applicationId: this.applicationId,
            hostFamilyId: hf.hostFamilyId,
            bookmark: !hf.bookmark
        }, () => { 
            hf.bookmark = !hf.bookmark
        })
    }

    clearNoChildFilter() {
        this.filters.minChild = 1;
        this.filters.maxChild = 5;

        this.refreshResult();
    }

    clearAgeFilter() {
        this.filters.fromAge = 0;
        this.filters.toAge = 6;

        this.refreshResult();
    }

    clearRegionFilter(key) {
        this.filters.region[key] = false;

        this.refreshResult()
    }

    clearFilter(skipTracking: boolean = false) {
        this.filters = {
            applicationId: this.applicationId,
            pageNumber: 0,
            pageSize: 20,

            fromAge: 0,
            toAge: 6,
            minChild: 1,
            maxChild: 5,
            region: {}
        };

        if (!skipTracking && this.Auth.user.isApplicant) {
            this.Activity.trackHFActivity({ applicationId: this.applicationId }, { type: 'APClearedFindHFFilter' });
        }

        this.refreshResult();
    }
}

angular
    .module('app')
    .controller('FindHostFamilyController', FindHostFamilyController)
